<template>
  <footer
    class="mx-auto max-w-3xl bg-white px-8 py-8 sm:p-6 lg:max-w-6xl lg:py-12"
  >
    <div class="space-y-6 lg:flex lg:space-y-0">
      <div class="mb-6 w-full md:mb-0 lg:w-2/5">
        <NuxtLink
          to="/"
          class="items-center"
        >
          <VeridisLogo />
        </NuxtLink>
        <span
          class="mt-5 block text-sm leading-relaxed text-gray-900 antialiased"
        >
          Veridis helps companies manage<br>
          their carbon footprints.
        </span>
        <div class="mt-5 flex space-x-6">
          <a
            href="#"
            target="_blank"
            class="text-gray-500 hover:text-gray-900"
          >
            <LinkedinIcon title="Zuno Carbon LinkedIn page" />
            <span class="sr-only">LinkedIn page</span>
          </a>
          <a
            href="#"
            target="_blank"
            class="text-gray-500 hover:text-gray-900"
          >
            <TwitterIcon title="Zuno Carbon Twitter page" />
            <span class="sr-only">Twitter page</span>
          </a>
          <a
            href="#"
            target="_blank"
            class="text-gray-500 hover:text-gray-900"
          >
            <FBIcon title="Zuno Carbon Facebook page" />
            <span class="sr-only">Facebook page</span>
          </a>
          <a
            href="#"
            target="_blank"
            class="text-gray-500 hover:text-gray-900"
          >
            <InstaIcon title="Zuno Carbon Instagram page" />
            <span class="sr-only">Instagram page</span>
          </a>
        </div>
      </div>
      <div class="grid w-full grid-cols-1 gap-6 lg:w-3/5 lg:grid-cols-3">
        <div>
          <h2 class="mb-6 text-sm font-semibold uppercase text-gray-900">
            About
          </h2>
          <ul class="text-sm text-gray-600">
            <li class="mb-3">
              <NuxtLink
                to="#About"
                class="hover:underline"
              >
                About
              </NuxtLink>
            </li>
            <li class="mb-3">
              <NuxtLink
                to="#Benefits"
                class="hover:underline"
              >Features & Benefits</NuxtLink>
            </li>
            <li class="mb-3">
              <NuxtLink
                to="/"
                class="hover:underline"
              >
                Pricing
              </NuxtLink>
            </li>
            <li class="mb-3">
              <NuxtLink
                to="#FAQ"
                class="hover:underline"
              >
                FAQ
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div>
          <h2 class="mb-6 text-sm font-semibold uppercase text-gray-900">
            Resources
          </h2>
          <ul class="space-y-3 text-sm text-gray-600">
            <li>
              <NuxtLink
                to="/"
                class="hover:underline"
              >
                Knowledge Base
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                to="/"
                class="hover:underline"
              >
                How-Tos
              </NuxtLink>
            </li>
            <li>
              <a
                href="mailto:info@zunocarbon.com"
                class="hover:underline"
              >Support</a>
            </li>
            <li>
              <button
                type="button"
                class="hover:underline"
                @click="login()"
              >
                Login
              </button>
            </li>
            <li>
              <a
                href="https://www.zunocarbon.com/privacy-policy-2"
                class="hover:underline"
                target="_blank"
              >Privacy Policy</a>
            </li>
            <li>
              <NuxtLink
                to="/data-handling"
                class="hover:underline"
              >Data Handling</NuxtLink>
            </li>
          </ul>
        </div>

        <div>
          <h2 class="mb-6 text-sm font-semibold uppercase text-gray-900">
            Contact Us
          </h2>
          <ul class="text-sm text-gray-600">
            <li class="mb-3">
              <a
                href="mailto:info@zunocarbon.com"
                class="flex gap-2 hover:underline"
              >
                <EnvelopeIcon />
                <span>info@zunocarbon.com</span>
              </a>
            </li>
            <li class="mb-3">
              <a
                href="tel:+1 23 567 890 000"
                class="flex gap-2 hover:underline"
              >
                <PhoneIcon />
                <span>+65 9116 8603</span>
              </a>
            </li>
            <li class="mb-3">
              <div class="flex gap-2 hover:underline">
                <MapIcon />
                <span>47B Tras Street,<br>
                  Singapore 078986</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8">
    <div class="text-center lg:items-center">
      <span class="text-sm text-gray-500 sm:text-center">&copy; {{ new Date().getFullYear() }}
        <NuxtLink
          to="/"
          class="hover:underline"
        >Veridis™ </NuxtLink> a Zuno
        Carbon product. All Rights Reserved.
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      protocol: process.env.NODE_ENV === 'development' ? 'http' : 'https',
    }
  },
  methods: {
    getBaseUrl() {
      window.location.href = `${this.protocol}://${this.$config.public.domain}/login?continue=true`
    },
    login() {
      this.$keycloak.login({
        redirectUri: `${this.protocol}://${this.$config.public.domain}/login`,
      })
    },
  },
}
</script>
